import { Box, Button, Heading, Text, ThemeContext } from '@vouched.id/vault';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { VouchedLogo } from '../reusable/vouched-logo';
export const SigninSsoError = () => {
    const navigate = useNavigate();
    const { tokens } = useContext(ThemeContext).theme;
    const { textMuted } = tokens.colors;
    return (React.createElement(Box, { display: ['block', 'flex'], height: "100vh", padding: ['spacing.large', 'spacing.none'], style: {
            boxSizing: 'border-box',
            background: 'var(--background-brand-gradient)'
        }, tag: "main" },
        React.createElement(Box, { alignItems: "center", backgroundColor: "colors.backgroundPrimary", display: "flex", flex: "1", flexDirection: "column", justifyContent: "center", paddingX: "spacing.large", paddingY: "spacing.xlarge", position: "relative", style: {
                borderRadius: ['spacing.default', '0'],
                boxSizing: 'border-box',
                top: '50%',
                transform: 'translateY(-50%)'
            } },
            React.createElement(Box, { display: ['block', 'none'], marginBottom: "spacing.large", textAlign: "center" },
                React.createElement(VouchedLogo, { maxWidth: "24rem", variant: "blue", width: "70%" })),
            React.createElement(Box, { textAlign: "center" },
                React.createElement(Heading, { style: { fontWeight: 'bold', color: textMuted }, tag: "h1", variation: "h3" }, "Authentication Failed"),
                React.createElement(Box, { marginTop: "spacing.small" },
                    React.createElement(Text, { style: {
                            color: textMuted,
                            fontSize: 'text.size.large',
                            textAlign: 'center'
                        }, tag: "p" }, "Contact your Administrator")),
                React.createElement(Box, { marginTop: "spacing.large" },
                    React.createElement(Button, { onClick: () => {
                            navigate('/signin');
                        }, type: "button", variation: "secondary" }, "Try Again")))),
        React.createElement(Box, { alignItems: "center", display: ['none', 'flex'], flex: "1", flexDirection: "column", justifyContent: "center", paddingX: "spacing.default" },
            React.createElement(VouchedLogo, { maxWidth: "32rem", variant: "white", width: "60%" }),
            React.createElement(Box, { marginTop: "spacing.large" },
                React.createElement(Text, { style: {
                        color: 'var(--color-white)',
                        fontWeight: '600',
                        fontSize: ['text.size.default', null, 'text.size.large']
                    }, tag: "span" }, "Know Who's On The Other End")))));
};
